/**
 * @generated SignedSource<<893e467ad84364fd216948bf162c4b31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditTextElementV2Input = {
  clientMutationId?: string | null;
  text: string;
  textElementId: string;
  title: string;
};
export type textElementForm_EditTextElementMutation$variables = {
  input: EditTextElementV2Input;
};
export type textElementForm_EditTextElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editTextElement: {
        readonly textElement: {
          readonly " $fragmentSpreads": FragmentRefs<"textElementForm_TextElementFragment">;
        };
      } | null;
    };
  };
};
export type textElementForm_EditTextElementMutation = {
  response: textElementForm_EditTextElementMutation$data;
  variables: textElementForm_EditTextElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "textElementForm_EditTextElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditTextElementV2Payload",
                "kind": "LinkedField",
                "name": "editTextElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextElementV2",
                    "kind": "LinkedField",
                    "name": "textElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "textElementForm_TextElementFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "textElementForm_EditTextElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditTextElementV2Payload",
                "kind": "LinkedField",
                "name": "editTextElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextElementV2",
                    "kind": "LinkedField",
                    "name": "textElement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6d03daa07ae140c44af6e7b41cfffccc",
    "id": null,
    "metadata": {},
    "name": "textElementForm_EditTextElementMutation",
    "operationKind": "mutation",
    "text": "mutation textElementForm_EditTextElementMutation(\n  $input: EditTextElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      editTextElement(input: $input) {\n        textElement {\n          ...textElementForm_TextElementFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment textElementForm_TextElementFragment on TextElementV2 {\n  id\n  title\n  text\n}\n"
  }
};
})();

(node as any).hash = "e455f73a8e91dfc6ea9cd530eae73b41";

export default node;
